"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evalRule = exports.evalRules = exports.evalFlag = exports.Operator = void 0;
var xxhashjs_1 = __importDefault(require("xxhashjs"));
var Operator;
(function (Operator) {
    Operator["Empty"] = "EMPTY";
    Operator["True"] = "TRUE";
    Operator["StrEqual"] = "STR_EQUAL";
    Operator["StrEqualSoft"] = "STR_EQUAL_SOFT";
    Operator["StrStartsWith"] = "STR_STARTS_WITH";
    Operator["StrEndsWith"] = "STR_ENDS_WITH";
    Operator["StrContains"] = "STR_CONTAINS";
    Operator["Percentage"] = "PERCENTAGE";
    Operator["ArrOverlap"] = "ARR_OVERLAP";
    Operator["RegExp"] = "REGEXP";
    Operator["StrBefore"] = "STR_BEFORE";
    Operator["StrAfter"] = "STR_AFTER";
    Operator["Eq"] = "EQ";
    Operator["Lt"] = "LT";
    Operator["Gt"] = "GT";
    Operator["DateAfter"] = "DATE_AFTER";
    Operator["DateBefore"] = "DATE_BEFORE";
    Operator["SemverEq"] = "SEMVER_EQ";
    Operator["SemverGte"] = "SEMVER_GTE";
    Operator["SemverLte"] = "SEMVER_LTE";
})(Operator = exports.Operator || (exports.Operator = {}));
var evalFlag = function (context, flag) {
    var e_1, _a;
    try {
        for (var _b = __values(flag.conditions), _c = _b.next(); !_c.done; _c = _b.next()) {
            var condition = _c.value;
            if ((0, exports.evalRules)(context, condition.rules)) {
                return condition.variation.active ? condition.variation.value : undefined;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return flag.defaultVariation.active ? flag.defaultVariation.value : undefined;
};
exports.evalFlag = evalFlag;
var evalRules = function (context, rules) {
    return rules.every(function (rule) { return (0, exports.evalRule)(rule, context[rule.key]); });
};
exports.evalRules = evalRules;
var evalRule = function (rule, value) {
    if (rule.operator === Operator.Empty) {
        var isEmpty = value === undefined || value === null || value === '';
        return isEmpty !== rule.negate;
    }
    if (value === undefined || value === null) {
        return false;
    }
    if (rule.operator === Operator.StrEqual) {
        if (typeof value !== 'string') {
            return false;
        }
        return rule.values.includes(value) !== rule.negate;
    }
    if (rule.operator === Operator.StrEqualSoft) {
        if (typeof value !== 'string' && typeof value !== 'number') {
            return false;
        }
        return rule.values.includes(String(value).toLowerCase()) !== rule.negate;
    }
    if (rule.operator === Operator.StrContains) {
        if (typeof value !== 'string') {
            return false;
        }
        return rule.values.some(function (val) { return value.includes(val); }) !== rule.negate;
    }
    if (rule.operator === Operator.StrStartsWith) {
        if (typeof value !== 'string') {
            return false;
        }
        return rule.values.some(function (val) { return value.startsWith(val); }) !== rule.negate;
    }
    if (rule.operator === Operator.StrEndsWith) {
        if (typeof value !== 'string') {
            return false;
        }
        return rule.values.some(function (val) { return value.endsWith(val); }) !== rule.negate;
    }
    if (rule.operator === Operator.StrAfter) {
        if (typeof value !== 'string') {
            return false;
        }
        return value >= rule.value;
    }
    if (rule.operator === Operator.StrBefore) {
        if (typeof value !== 'string') {
            return false;
        }
        return value <= rule.value;
    }
    if (rule.operator === Operator.RegExp) {
        if (typeof value !== 'string') {
            return false;
        }
        return new RegExp(rule.value).test(value) !== rule.negate;
    }
    if (rule.operator === Operator.True) {
        return value === !rule.negate;
    }
    if (rule.operator === Operator.Eq) {
        if (typeof value !== 'number') {
            return false;
        }
        return (value === rule.value) !== rule.negate;
    }
    if (rule.operator === Operator.Lt) {
        if (typeof value !== 'number') {
            return false;
        }
        return value < rule.value !== rule.negate;
    }
    if (rule.operator === Operator.Gt) {
        if (typeof value !== 'number') {
            return false;
        }
        return value > rule.value !== rule.negate;
    }
    if (rule.operator === Operator.ArrOverlap) {
        if (!Array.isArray(value)) {
            return false;
        }
        return value.some(function (val) { return rule.values.includes(val); }) !== rule.negate;
    }
    if (rule.operator === Operator.DateAfter) {
        if (typeof value === 'string') {
            var val = value.slice(0, '2000-01-01T23:59:59'.length) +
                '2000-01-01T23:59:59'.slice(value.length);
            return rule.iso <= val;
        }
        if (typeof value === 'number') {
            if (value < 631152000000) {
                return value * 1000 >= rule.timestamp;
            }
            return value >= rule.timestamp;
        }
        return false;
    }
    if (rule.operator === Operator.DateBefore) {
        if (typeof value === 'string') {
            var val = value.slice(0, '2000-01-01T00:00:00'.length) +
                '2000-01-01T00:00:00'.slice(value.length);
            return rule.iso >= val;
        }
        if (typeof value === 'number') {
            if (value < 631152000000) {
                return value * 1000 <= rule.timestamp;
            }
            return value <= rule.timestamp;
        }
        return false;
    }
    if (rule.operator === Operator.SemverEq) {
        if (typeof value !== 'string') {
            return false;
        }
        var semVer = value.split('.').map(Number);
        for (var i = 0; i < rule.version.length; i++) {
            if (semVer[i] === undefined || semVer[i] !== rule.version[i]) {
                return rule.negate;
            }
        }
        return !rule.negate;
    }
    if (rule.operator === Operator.SemverGte) {
        if (typeof value !== 'string') {
            return false;
        }
        var semVer = value.split('.').map(Number);
        for (var i = 0; i < rule.version.length; i++) {
            if (semVer[i] === undefined) {
                return rule.negate;
            }
            if (semVer[i] > rule.version[i]) {
                return !rule.negate;
            }
            if (semVer[i] < rule.version[i]) {
                return rule.negate;
            }
        }
        return !rule.negate;
    }
    if (rule.operator === Operator.SemverLte) {
        if (typeof value !== 'string') {
            return false;
        }
        var semVer = value.split('.').map(Number);
        for (var i = 0; i < rule.version.length; i++) {
            if (semVer[i] === undefined) {
                return rule.negate;
            }
            if (semVer[i] < rule.version[i]) {
                return !rule.negate;
            }
            if (semVer[i] > rule.version[i]) {
                return rule.negate;
            }
        }
        return !rule.negate;
    }
    if (rule.operator === Operator.Percentage) {
        if (typeof value !== 'string' && typeof value !== 'number') {
            return false;
        }
        var probability = (xxhashjs_1.default.h32(String(value), rule.seed).toNumber() >>> 0) / 0xffffffff;
        if (probability === 1) {
            probability -= Number.EPSILON;
        }
        return probability >= rule.rangeStart && probability < rule.rangeEnd;
    }
    throw new Error("Unsupported operator ".concat(rule.operator));
};
exports.evalRule = evalRule;
//# sourceMappingURL=index.js.map